import "./App.css";
import { Outlet, Route, Routes } from "react-router-dom";
import adminPanelRoutes from "./routes/adminPanelRoutes";
// import AdminLogin from "./pages/DefaultPages/Login/Login";
import { AdminAuthContextProvider } from "./store/adminStore/admin-auth-context";
import AdminRequireFormAuth from "./RoutesControllers/AdminRequireFormAuth";
import defaultRoutes from "./routes/defaultRoutes";
import IsLoggedInInERP from "./RoutesControllers/IsLoggedInInERP";
import Layout from "./Components/Layout/ThemeLayout";
// import Layout from "./Components/LayoutWithHeader/ThemeLayout";
import { LayoutContextProvider } from "./store/adminStore/layoutStore/layout-context";
import allListRoutes from "./routes/allListsRoutes";
import AdminRequireListAuth from "./RoutesControllers/AdminRequireListAuth";
import ERPHome from "./pages/DefaultPages/ERPHome/ERPHome";
import ForgetPassword from "./pages/DefaultPages/ForgetPassword/ForgetPassword";
import AdminRequireLoggedIn from "./RoutesControllers/AdminRequireLoggedIn";
import applicantformsRoute from "./routes/applicantformsRoute";
import fRMsRoutes from "./routes/fRMsRoutes";
// import PDDLogin from "./pages/HRINF/PersonnelDocumentDigitization/PDDLogin/PDDLogin";
import personnelDigitizationRoutes from "./routes/personnelDigitizationRoutes";
import IsLoggedInInApplicant from "./RoutesControllers/Applicant/IsLoggedInInApplicant";
import RequireApplicantFormAuth from "./RoutesControllers/Applicant/RequireApplicantFormAuth";
import IsLoggedInInPDD from "./RoutesControllers/PDD/IsLoggedInInPDD";
import RequirePDDFormAuth from "./RoutesControllers/PDD/RequirePDDFormAuth";
import { ApplicantAuthContextProvider } from "./store/applicantStore/applicant-auth-context";
import { PDDAuthContextProvider } from "./store/pddStore/pdd-auth-context";
// import {SRMAuth}
import ApplicantLogin from "./pages/HRINF/ApplicantInformation/Login/Login";
import FNMLogin from "./pages/DefaultPages/FNMLogin/Login";
import ERPLogin from "./pages/DefaultPages/ERPLogin/ERPLogin";
import Login from "./pages/HRINF/PersonnelDocumentDigitization/PDDLogin/Login";
import initialOpenDatabase from "./utils/IndexedDB/initialOpenDatabase";
import { Suspense, useEffect } from "react";
import SignupWithHoda from "./pages/TestPages/SignupWithHoda/SignupWithHoda";
import { SRMAuthContextProvider } from "./store/saleRepresentativesManagementStore/saleRepresentativesManagement-auth-context";
import { FNMAuthContextProvider } from "./store/FNMStore/FNM-auth-context";
import IsLoggedInInSRM from "./RoutesControllers/SRM/IsLoggedInInSRM";
import IsLoggedInInFNM from "./RoutesControllers/FNM/IsLoggedInInFNM";
import RequireSRMFormAuth from "./RoutesControllers/SRM/RequireSRMFormAuth";
import testRoutes from "./routes/testRoutes";
import RequireFNMFormAuth from "./RoutesControllers/FNM/RequireFNMFormAuth";
import userInformationRoute from "./routes/userInformationRoutes";
import SRMLogin from "./pages/SRM/Login/Login";

function App() {
  useEffect(() => {
    const createIndexedDBStores = async () => {
      try {
        await initialOpenDatabase(
          "ERP_DB",
          ["Client_Details", "Field_Access", "Enums", "List_Ui_State"],
          1,
        );
      } catch (error) {}
    };

    createIndexedDBStores();
  }, []);
  return (
    <Routes>
      {/* ***** ERP PAGES ***** */}
      <Route element={<AdminAuthContextProvider />}>
        <Route element={<IsLoggedInInERP />}>
          <Route element={<LayoutContextProvider />}>
            <Route element={<Layout />}>
              {adminPanelRoutes.map((route, index) => (
                <Route element={<AdminRequireFormAuth route={route} />} key={`${route.path}-${index}`}>
                  <Route {...route} />
                </Route>
              ))}
              {allListRoutes.map((route, index) => (
                <Route element={<AdminRequireListAuth route={route} />} key={`${route.path}-${index}`}>
                  <Route {...route} />
                </Route>
              ))}
              <Route element={<AdminRequireLoggedIn />}>
                <Route path="/admin-home-page" element={<ERPHome />} />
                <Route path="/change-password" element={<ForgetPassword />} />
              </Route>
            </Route>
          </Route>
          <Route path="/admin/login" element={<ERPLogin />} />
        </Route>
      </Route>
      <Route path="/login-signup" element={<SignupWithHoda />} />
      {/* ***** Sale Representatives Management PAGES ***** */}
      <Route element={<SRMAuthContextProvider />}>
        <Route element={<IsLoggedInInSRM />}>
          {userInformationRoute.map((route, index) => (
            <Route element={<RequireSRMFormAuth />} key={`${route.path}-${index}`}>
              <Route {...route} />
            </Route>
          ))}
          <Route element={<SRMLogin />} path="/sale-representatives-management/login" />
        </Route>
      </Route>
      {/* ***** FormNetworkMarketer PAGES ***** */}
      <Route element={<FNMAuthContextProvider />}>
        <Route element={<IsLoggedInInFNM />}>
          {fRMsRoutes.map((route, index) => (
            <Route element={<RequireFNMFormAuth />} key={`${route.path}-${index}`}>
              <Route {...route} key={route.key} />
            </Route>
          ))}
          <Route element={<FNMLogin />} path="/form-network-marketer/login" />
        </Route>
      </Route>
      {/* ***** JONAPPLY PAGES ***** */}
      <Route element={<ApplicantAuthContextProvider />}>
        <Route element={<IsLoggedInInApplicant />}>
          {applicantformsRoute.map((route, index) => (
            <Route element={<RequireApplicantFormAuth />} key={`${route.path}-${index}`}>
              <Route {...route} />
            </Route>
          ))}
          <Route element={<ApplicantLogin />} path="/applicant-information/login" />
        </Route>
      </Route>
      {/****** PERSONNEL DD PAGES ***** */}
      <Route element={<PDDAuthContextProvider />}>
        <Route element={<IsLoggedInInPDD />}>
          {personnelDigitizationRoutes.map((route, index) => (
            <Route element={<RequirePDDFormAuth />} key={`${route.path}-${index}`}>
              <Route {...route} />
            </Route>
          ))}
          <Route element={<Login />} path="/personnel-document-digitization/login" />
        </Route>
      </Route>

      {defaultRoutes.map((route, index) => (
        // <Route element={<RequireFormAuth route={route} />} key={route.key}>
        <Route {...route} key={`${route.path}-${index}`} />
        // </Route>
      ))}
      <Route
        element={
          <Suspense fallback={<p>loading ... XXX</p>}>
            <Outlet />
          </Suspense>
        }
      >
        {testRoutes.map((route, index) => (
          <Route {...route} key={`${route.path}-${index}`} />
        ))}
      </Route>
    </Routes>
  );
}

export default App;
